import { render } from "./IssuersListPage.vue?vue&type=template&id=4ce5d73c"
import script from "./IssuersListPage.vue?vue&type=script&lang=js"
export * from "./IssuersListPage.vue?vue&type=script&lang=js"

import "./IssuersListPage.vue?vue&type=style&index=0&id=4ce5d73c&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__